import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionContactosListaItemComponent {
  idCliente
  data
  onDelete
  onChange
  error = null
  ClienteInformacionContactosEliminar = null

  eliminar () {
    this.ClienteInformacionContactosEliminar.open()
      .then((data) => {
        if (data && data.eliminado) this.onDelete()
      })
  }
}

module.component('clienteInformacionContactosListaItem', {
  controller: ClienteInformacionContactosListaItemComponent,
  template,
  bindings: {
    idCliente: '<',
    idAccionista: '<',
    data: '<',
    onDelete: '&',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/contactos/lista/item/component.js